import React, {useEffect} from "react";
import {Card, CardBody, CardHeader} from "../../../../_metronic/_partials/controls";
import {CustomersTable} from "./components/CustomersTable";
import {CustomersUIProvider} from "./CustomersUIContext";
import {useDispatch} from "react-redux";
import {fetchCustomers} from "../../../../redux/customers/customersActions";
import {CustomerCreate} from "./CustomerCreate";
import { useLanguageForShared } from "../../../../shared/utils/languages/useLanguageForShared";

export function CustomersPage({ history }) {
  const {t} = useLanguageForShared()

  const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchCustomers(t))
    }, [])
  return (
      <div className="row">
        <div className="col-12">
          <Card>
            <CardHeader title={t("sgbo.customers")}/>
            <CardBody>
                <CustomerCreate />
                <CustomersUIProvider>
                    <CustomersTable/>
                </CustomersUIProvider>
            </CardBody>
          </Card>
        </div>
      </div>
  );
}
